import React, { Component } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import toast from 'react-hot-toast'

class ProductReplacementDialog extends Component {
  state = {
    reimburseMethod: '',
    replacementAmount: '',
    selectedServicer: '',
    isValidReimburseMethod: null,
    isValidatedReimburseMethod: false,
    isValidReplacementAmount: null,
    isValidatedReplacementAmount: false,
    isValidSelectedServicer: null,
    isValidatedSelectedServicer: false,
  }
  resetValidation = () => {
    this.setState({
      isValidReimburseMethod: null,
      isValidatedReimburseMethod: false,
      isValidReplacementAmount: null,
      isValidatedReplacementAmount: false,
      isValidSelectedServicer: null,
      isValidatedSelectedServicer: false,
    })
  }
  validateModal = () => {
    const { reimburseMethod, replacementAmount, selectedServicer } = this.state

    this.setState({
      // isValidReimburseMethod: reimburseMethod?.length > 0 ? true : false,
      // isValidatedReimburseMethod: true,
      isValidReplacementAmount: replacementAmount?.length > 0 ? true : false,
      isValidatedReplacementAmount: true,
      isValidSelectedServicer: selectedServicer?.length > 0 ? true : false,
      isValidatedSelectedServicer: true,
    })
    return (
      // reimburseMethod?.length > 0 &&
      // replacementAmount?.length > 0 &&
      selectedServicer?.length > 0
    )
  }
  handleInputChange = (event) => {
    this.resetValidation()
    const { target } = event
    const { id, value } = target
    this.setState({
      [id]: value,
    })
  }
  handleSubmit = async () => {
    if (this.validateModal()) {
      const { reimburseMethod, replacementAmount, selectedServicer } = this.state
      const { contractLevelRemainingLability, selectedProduct } = this.props
      const remainingPLOL = parseFloat(selectedProduct?.liabilityRemaining) || 0
      const remainingCLOL = parseFloat(contractLevelRemainingLability) || 0

      // Choose the lower liability limit
      const remaining = Math.min(remainingPLOL, remainingCLOL)

      if (remaining < replacementAmount) {
        toast.error('Requested amount is greater then remaining lol')
        return
      }
      const data = {
        reimburseMethod: reimburseMethod,
        replacementAmount: replacementAmount,
        selectedServicer: selectedServicer,
      }
      this.props.handleProductReplacementClaim(data)
    } else {
    }
  }

  render() {
    const {
      reimburseMethod,
      replacementAmount,
      selectedServicer,
      isValidReimburseMethod,
      isValidatedReimburseMethod,
      isValidReplacementAmount,
      isValidatedReplacementAmount,
      isValidatedSelectedServicer,
      isValidSelectedServicer,
    } = this.state
    const {
      isOpenProductReplacementDialog,
      handleCloseProductReplacementDialog,
      productReplacementServicerList,
    } = this.props

    return (
      <Modal show={isOpenProductReplacementDialog}>
        <Modal.Header>
          <Modal.Title>Product Replacement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <React.Fragment>
            <Form.Group as={Row} controlId='selectedServicer'>
              <Form.Label column xs={6}>
                Servicer :
              </Form.Label>
              <Col xs={6}>
                <Form.Control
                  as='select'
                  value={selectedServicer}
                  autoComplete='off'
                  className={
                    !isValidatedSelectedServicer
                      ? null
                      : isValidSelectedServicer
                      ? 'is-valid'
                      : 'is-invalid'
                  }
                  onChange={(event) => {
                    this.handleInputChange(event)
                  }}
                  size='sm'
                >
                  <option key='' value=''>
                    Select Servicer...
                  </option>
                  {Array.isArray(productReplacementServicerList) &&
                  productReplacementServicerList?.length > 0 ? (
                    productReplacementServicerList?.map((item, i) => (
                      <option key={i} value={item?.servicerAccountId}>
                        {`${item?.servicerAccountId}-(${item?.serviceProvider})`}
                      </option>
                    ))
                  ) : (
                    <option key='no-data' value='' disabled>
                      No data found
                    </option>
                  )}
                </Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId='replacementAmount'>
              <Form.Label column xs={6}>
                Replacement Amount :
              </Form.Label>
              <Col xs={6}>
                <Form.Control
                  autoComplete='off'
                  size='sm'
                  type='number'
                  placeholder='Replacement Amount'
                  value={replacementAmount}
                  // className={
                  //   !isValidatedReplacementAmount
                  //     ? null
                  //     : isValidReplacementAmount
                  //     ? 'is-valid'
                  //     : 'is-invalid'
                  // }
                  onChange={(event) => this.handleInputChange(event)}
                />
              </Col>
            </Form.Group>
            {/* <Form.Group as={Row} controlId='reimburseMethod'>
              <Form.Label column xs={6}>
                Reimburse Method :
              </Form.Label>
              <Col xs={6}>
                <Form.Control
                  as='select'
                  value={reimburseMethod}
                  autoComplete='off'
                  className={
                    !isValidatedReimburseMethod
                      ? null
                      : isValidReimburseMethod
                      ? 'is-valid'
                      : 'is-invalid'
                  }
                  onChange={(event) => {
                    this.handleInputChange(event)
                  }}
                  size='sm'
                >
                  <option key='' value=''>
                    Select Reimburse Method...
                  </option>
                  {['PayPal', 'Check'].length > 0 ? (
                    ['PayPal', 'Check']?.map((item, i) => (
                      <option key={i} value={item}>
                        {item}
                      </option>
                    ))
                  ) : (
                    <option key='no-data' value='' disabled>
                      No data found
                    </option>
                  )}
                </Form.Control>
              </Col>
            </Form.Group> */}
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => handleCloseProductReplacementDialog()}>
            Close
          </Button>
          <Button variant='primary' onClick={() => this.handleSubmit()}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
export default ProductReplacementDialog
